import { render, staticRenderFns } from "./Func53Detalhe.vue?vue&type=template&id=6b831920&scoped=true"
import script from "./Func53Detalhe.vue?vue&type=script&lang=js"
export * from "./Func53Detalhe.vue?vue&type=script&lang=js"
import style0 from "./Func53Detalhe.vue?vue&type=style&index=0&id=6b831920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b831920",
  null
  
)

export default component.exports